import { cartCountEndpoint } from 'api/header/useCartCount';
import { useSWRConfig } from 'swr';
import { patch } from '../base';
import { checkoutItemsEndpoint } from '../checkout/useCheckoutItems';

export function useAddToCart() {
  const { mutate } = useSWRConfig();

  return async ({ sku, quantity, addedFromCheckout = false }) => {
    await patch('tee/cart', { sku, quantity, addedFromCheckout });
    await Promise.all([
      mutate(checkoutItemsEndpoint),
      mutate(cartCountEndpoint),
    ]);
  };
}
